const clientItems = [
  {
    title: 'nav.dashboard',
    iconName: 'home',
    iconActiveName: 'home-blue',
    iconDisableName: 'home-lighten',
    path: '/dashboard',
    activePaths: ['/dashboard'],
    disable: false,
    isTest: false,
    comingSoon: true
  },
  {
    title: 'nav.explore',
    iconName: 'explore',
    iconActiveName: 'explore-blue',
    iconDisableName: 'explore-lighten',
    path: '/explore',
    activePaths: ['/explore', '/checkout'],
    disable: false,
    isTest: false,
    comingSoon: false
  },
  {
    title: 'nav.requests',
    iconName: 'requests',
    iconActiveName: 'requests-blue',
    iconDisableName: 'requests-lighten',
    path: '/team-requests',
    activePaths: ['/team-requests'],
    disable: false,
    isTest: false,
    comingSoon: false
  },
  {
    title: 'nav.myTeams',
    iconName: 'team',
    iconActiveName: 'team-blue',
    iconDisableName: 'team-lighten',
    disable: false,
    isTest: false,
    comingSoon: false,
    items: [
      {
        title: 'nav.myTeamsCandidates',
        iconActiveName: 'team-blue',
        iconDisableName: 'team-lighten',
        path: '/teams/candidates',
        activePaths: ['/teams/candidates'],
        disable: false,
        isTest: false,
        comingSoon: false
      },
      {
        title: 'nav.myTeamsTeams',
        iconActiveName: 'team-blue',
        iconDisableName: 'team-lighten',
        path: '/teams/teams',
        activePaths: ['/teams/teams'],
        disable: false,
        isTest: false,
        comingSoon: true
      },
      {
        title: 'nav.myTeamsCalendar',
        iconActiveName: 'team-blue',
        iconDisableName: 'team-lighten',
        path: '/teams/calendar',
        activePaths: ['/teams/calendar'],
        disable: false,
        isTest: false,
        comingSoon: true
      }
    ]
  }
];

export default clientItems;
